import {
  CONTENT_TYPE_FIELD,
  CpsDocument,
  DOC_ID_FIELD,
  EXTENSION_FIELD,
  PERMISSIONS_FIELD
} from '@cs-cms/types';

export type CpsGridCommonProperties = {
  [DOC_ID_FIELD]: string;
  [CONTENT_TYPE_FIELD]: string;
  [EXTENSION_FIELD]: string;
  [PERMISSIONS_FIELD]: number[];
};

export type CpsGridDocument = CpsGridCommonProperties & CpsDocument;

export const GRID_LAYOUT_FALLBACK_HEIGHT_PX = 480;
export const GRID_LAYOUT_FALLBACK_WIDTH_PX = 960;
